"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LoadConfig_1 = require("./components/layout/LoadConfig");
const material_1 = require("@mui/material");
const react_1 = require("react");
const Providers_1 = __importDefault(require("./Providers"));
const ModalMode_1 = __importDefault(require("./components/ModalMode/ModalMode"));
const MultiStepForm_1 = require("./components/MultiStepForm");
const ValidationService_1 = require("./services/ValidationService");
const system_1 = require("@mui/system");
const fee_table_1 = __importDefault(require("../fee-table"));
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const TableRows_1 = __importDefault(require("@mui/icons-material/TableRows"));
const defaultProps = {
    school: 'feesableCollegeA',
    hidesidebar: false,
    hideheading: false,
    headingtext: 'Fee Calculator',
    includepadding: false,
    modalbuttonlabel: 'Calculate Fees',
    modalmode: false,
    testmode: false,
    type: 'live',
    showfeetable: false,
    showperterm: false,
};
const StyledAccordion = (0, system_1.styled)(material_1.Accordion)(({ theme }) => ({
    boxShadow: 'none',
    border: `1px solid ${theme.palette.custom.surfaceDark}`,
    '&.MuiAccordion-root': {
        padding: 1,
    },
}));
const StyledAccordionSummary = (0, system_1.styled)(material_1.AccordionSummary)(() => ({
    '& .MuiAccordionSummary-content': {
        alignItems: 'center',
        gap: 1,
    },
}));
function Feesable(props) {
    // Setup default config parameters that can be passed in on embed
    const defaultData = {
        includeSidebar: !props.hidesidebar,
        hideHeading: props.modalmode ? true : props.hideheading,
        headingText: props.headingtext,
        includePadding: props.includepadding,
        testMode: props.testmode || false,
        type: props.type,
        showFeeTable: props.showfeetable,
        showPerTerm: props.showperterm,
    };
    const validator = (0, react_1.useMemo)(() => {
        return new ValidationService_1.ValidationService();
    }, []);
    const FeeTableAccordion = () => {
        return ((0, jsx_runtime_1.jsxs)(StyledAccordion, { children: [(0, jsx_runtime_1.jsxs)(StyledAccordionSummary, { expandIcon: (0, jsx_runtime_1.jsx)(ExpandMore_1.default, {}), children: [(0, jsx_runtime_1.jsx)(TableRows_1.default, { color: "primary" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { children: (0, jsx_runtime_1.jsx)("strong", { style: { marginRight: 2 }, children: "Table of Fees" }) })] }), (0, jsx_runtime_1.jsx)(material_1.AccordionDetails, { children: (0, jsx_runtime_1.jsx)(fee_table_1.default, { showPerTerm: props.showperterm }) })] }));
    };
    const renderMain = () => {
        if (props.modalmode) {
            return ((0, jsx_runtime_1.jsxs)(ModalMode_1.default, { buttonLabel: props.modalbuttonlabel, modalTitle: props.headingtext, children: [(0, jsx_runtime_1.jsx)(MultiStepForm_1.MultiStepForm, { validator: validator }), props.showfeetable && ((0, jsx_runtime_1.jsx)(system_1.Box, { p: 3, mt: 1, children: (0, jsx_runtime_1.jsx)(FeeTableAccordion, {}) }))] }));
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MultiStepForm_1.MultiStepForm, { validator: validator }), props.showfeetable && ((0, jsx_runtime_1.jsx)(system_1.Box, { p: 3, mt: 1, children: (0, jsx_runtime_1.jsx)(FeeTableAccordion, {}) }))] }));
    };
    return ((0, jsx_runtime_1.jsx)(material_1.StyledEngineProvider, { injectFirst: true, children: (0, jsx_runtime_1.jsx)(Providers_1.default, { children: (0, jsx_runtime_1.jsx)(LoadConfig_1.LoadConfig, { schoolId: props.school, defaultData: defaultData, children: renderMain() }) }) }));
}
Feesable.defaultProps = defaultProps;
exports.default = Feesable;
